export const TITLE = "title";
export const DATE = "date";
export const YEAR = "year";
export const TYPE = "type";
export const COMPANY = "company";
export const UPLOAD = "attachmentId";
export const DESCRIPTION = "newsDescription";

export const companyOptions = [
  { label: "OGI", value: "OGI" },
  { label: "OPIL", value: "OPIL" },
  { label: "MBAPL", value: "MBAPL" },
  { label: "KPL", value: "KPL" },
  { label: "SGFL", value: "SGFL" },
  { label: "SIPL", value: "SIPL" },
  { label: "NRIPL", value: "NRIPL" },
  { label: "STRIVE4X", value: "STRIVE4X" },
  { label: "SNDOSS(CSR)", value: "SNDOSS" },
];
